import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { QuestionZod } from 'types/zod/question';
import { QuestionnaireTypeCodeZod } from 'types/zod/questionnaire-type-code';

const isLocalhost = ['localhost', '192.168'].some((host) => window.location.host.includes(host));
const resourcesBackend = axios.create({ baseURL: 'http://localhost:8090' });
const api = isLocalhost ? resourcesBackend : axios;

const QuestionnairesApi = {
    getQuestionnaire: strictQuery({
        In: z.object({ questionnaireType: QuestionnaireTypeCodeZod, state: z.string() }),
        Out: QuestionZod,
        handler: ({ questionnaireType, state }) =>
            axios.get(`/questionnaires/${questionnaireType}`, { params: { state } }),
    }),

    getDocumentTypes: strictQuery({
        In: z.string(),
        Out: z.array(z.string()),
        handler: (questionnaireType) => axios.get(`/questionnaires/${questionnaireType}/document_types`),
    }),

    getQTypes: strictQuery({
        In: z.void(),
        Out: z.array(QuestionnaireTypeCodeZod),
        handler: () => axios.get('/qtypes'),
    }),
};

export default QuestionnairesApi;
